import poster from './../../assets/images/static/erpDashboard.jpg';
import codlogo from './../../assets/images/static/codlogo.png';
import chieflogo from './../../assets/images/static/chieflogo.png';

export const featureslist = [
  {
    id: 1,
    poster: poster,
    src: "https://s3.us-west-2.amazonaws.com/videos-eretailpoint.com/eretailVideo.mp4",
    img: codlogo,
    title: 'Mr. Cod'
  },
  {
    id: 2,
    poster: poster,
    src: "https://s3.us-west-2.amazonaws.com/videos-eretailpoint.com/eretailVideo.mp4",
    img: chieflogo,
    title: 'Chief'
  },
  {
    id: 3,
    poster: poster,
    src: "https://s3.us-west-2.amazonaws.com/videos-eretailpoint.com/eretailVideo.mp4",
    img: codlogo,
    title: 'Mr. Cod'
  },
  {
    id: 4,
    poster: poster,
    src: "https://s3.us-west-2.amazonaws.com/videos-eretailpoint.com/eretailVideo.mp4",
    img: chieflogo,
    title: 'Chief'
  },
  {
    id: 5,
    poster: poster,
    src: "https://s3.us-west-2.amazonaws.com/videos-eretailpoint.com/eretailVideo.mp4",
    img: codlogo,
    title: 'Mr. Cod'
  }
]
